import { useTranslation } from 'react-i18next';
import { Chip, Tooltip } from '@mui/material';
import { AccessTime } from '@mui/icons-material';

import { useHoldCountdown } from '../holdCountdown';
import { formatHoldExpiry } from '../format';

interface Props {
  /** Vencimiento publicado por el proveedor para ESTA reserva. */
  expiresAt?: string;
}

/**
 * Cuánto le queda a la reserva antes de expirar sola.
 *
 * Neutro casi todo el tiempo y ámbar al final: un reloj de alerta que dura dos
 * días deja de significar algo. Sin fecha publicada no se dibuja nada — no hay
 * reloj que mostrar, y no es lo mismo que "venció".
 */
export function HoldCountdown({ expiresAt }: Props) {
  const { t } = useTranslation();
  const countdown = useHoldCountdown(expiresAt);

  if (countdown.status === 'unknown') return null;

  const expired = countdown.status === 'expired';

  return (
    <Tooltip
      title={
        expiresAt
          ? t('travelServices.booking.expiresAt', {
            date: formatHoldExpiry(expiresAt),
          })
          : ''
      }
    >
      <Chip
        size="small"
        icon={<AccessTime />}
        color={expired ? 'error' : countdown.status === 'ending' ? 'warning' : 'default'}
        variant={countdown.status === 'running' ? 'outlined' : 'filled'}
        label={
          expired
            ? t('travelServices.booking.holdExpired')
            : t('travelServices.booking.holdExpiresIn', { time: countdown.label })
        }
        sx={{ fontVariantNumeric: 'tabular-nums' }}
      />
    </Tooltip>
  );
}
